'use strict';


import { Form } from '../../interfaces/Form';
import { BaseElement } from '../../interfaces/BaseElement';
import { changeLangToCurrent } from '../langSwitcher/langSwitcher';
import { isMobile } from '../../../settings';
import { Preview } from '../preview/Preview';
import { PopUp } from '../../interfaces/pages/PopUp';
import { changeFormTitle, customiseForm, moveFormToBlock } from './form';
import { CustomerContactNow } from '../../menu/contactUs/CustomerContactNow';

export class McIdLeadForm {
	constructor () {
		const fields = [
			{
				type: 'text',
				placeholder: 'mcIdSignInName',
				value:'',
				name: 'Fname',
				required: true,
			},
			{
				type: 'email',
				name: 'Email',
				value:'',
				placeholder: 'mcIdSignInEmail',
				required: true
			},
			{
				type: 'tel',
				name: 'Mobile',
				value:'',
				placeholder: 'mcIdSignInPhone',
				required: true
			}
		];
		
		const params = {
			className: 'mc-id__lead-form',
			allowedKey: '',
			titleKey: 'mcIdLeadFormTitle',
			submitKey: 'mcIdSingInSubmit',
			formName: 'mcIdLeadForm'
		};
		
		this.form = new Form(fields,params);
		this.form.create();
		let firstCheckboxSelected = true;
		let secondCheckboxSelected = true;
		
		//First checkbox
		const allowedContainer = new BaseElement()
			.addClass('form__allowed-container','mc-id__lead-form__allowed-container')
			.appendTo(this.form.submitBtn.DOMElement,'beforebegin')
			.DOMElement;
		
		new BaseElement('input')
			.addClass('form__allowed-input','mc-id__lead-form__allowed-input')
			.addAttribute('type','checkbox')
			.addAttribute('checked',true)
			.event('change', (e) => {
				firstCheckboxSelected = !!e.target.checked;
				setSubmitBtnState();
			})
			.appendTo(allowedContainer);
		
		new BaseElement('p')
			.addClass('form__allowed-text','mc-id__lead-form__allowed-text','language-string')
			.addAttribute('data-dictionary','allowedText')
			.innerHtml(changeLangToCurrent('allowedText'))
			.appendTo(allowedContainer)
			.DOMElement;
		
		//Second checkbox
		const conditionContainer = new BaseElement()
			.addClass('form__allowed-container','mc-id__lead-form__allowed-container')
			.appendTo(this.form.submitBtn.DOMElement,'beforebegin')
			.DOMElement;
		
		new BaseElement('input')
			.addClass('form__allowed-input','mc-id__lead-form__allowed-input')
			.addAttribute('type','checkbox')
			.addAttribute('checked',true)
			.event('change', (e) => {
				secondCheckboxSelected = !!e.target.checked;
				setSubmitBtnState();
			})
			.appendTo(conditionContainer);
		
		if (isMobile) {
			new BaseElement('a')
				.addClass('mc-id__lead-form__sub-title--conditions','language-string')
				.addAttribute('data-dictionary','phoneLoginTitle2')
				.innerHtml(changeLangToCurrent('phoneLoginTitle2'))
				.addAttribute('href','#')
				.event('click',(e) => {
					e.preventDefault();
					new Preview('/assets/privacy/condition.pdf');
				})
				.appendTo(conditionContainer)
				.DOMElement;
		} else {
			new BaseElement('a')
				.addClass('mc-id__lead-form__sub-title--conditions','language-string')
				.addAttribute('data-dictionary','phoneLoginTitle2')
				.innerHtml(changeLangToCurrent('phoneLoginTitle2'))
				.addAttribute('href','/assets/privacy/condition.pdf')
				.addAttribute('target','_blank')
				.appendTo(conditionContainer)
				.DOMElement;
		}
		
		const setSubmitBtnState = () => {
			if (firstCheckboxSelected && secondCheckboxSelected) {
				this.form.submitBtn?.deleteAttribute('disabled');
			} else {
				this.form.submitBtn?.addAttribute('disabled',true);
			}
		};
		
		this.form.setOnValidCallback((formData) => {
			const data = {
				form: {},
				source: 'dreams-iframe'
			};
			formData.forEach((value,key) => {
				data.form[key] = value;
			});
			
			window.parent.postMessage(data, "*");
			this.form.hide();
		});
		this.form.show();
	}
	
}


export class McIdDreamsForm {
	constructor () {
		
		this.popUp = new PopUp({
			id: 'dreams-form__popup',
			needsCloseBtn: true,
			destroy: true
		});
		
		if (CustomerContactNow.isActive) {
			this.popUp.container.addClass('customer-contact-now');
		}
		
		this.popUp.onClose = () => {
			setTimeout(() => {
				const parent = document.querySelector('.contact-us__content') || document.body;
				moveFormToBlock(parent);
				customiseForm(document.querySelector('.form__container-main'));
				changeFormTitle('leadFormTitle');
			},250);
			this.popUp.hide();
		};
		
		moveFormToBlock(this.popUp.content);
		customiseForm(document.querySelector('.form__container-main'));
		changeFormTitle('leadFormTitle');
		this.popUp.show();
	}
}
